__turbopack_context__.v({
  "active": "modal-trigger-button-module-scss-module__gRAyPW__active",
  "button": "modal-trigger-button-module-scss-module__gRAyPW__button",
  "point": "modal-trigger-button-module-scss-module__gRAyPW__point",
  "pointPulse": "modal-trigger-button-module-scss-module__gRAyPW__pointPulse",
});
